
export const environment = {
  production:'false',
  apiUrl:'https://pae.gestion.logistica.back.candoit.com.ar',
  frontUrl:'https://pae.gestion.logistica.candoit.com.ar',
  client_secret : 'tn1234',
  clientId: 'ef2ec94b-2e18-4fd1-a722-48c3d60dacf3',
  redirectUri: 'https://pae.gestion.logistica.candoit.com.ar/',
  authority:'https://login.microsoftonline.com/8cb3c63f-2956-4d28-b216-acb701237c25'
};
